import { useAccount, useConnect, useEnsAvatar, useEnsName } from "wagmi"
import { useAccountModal } from "@rainbow-me/rainbowkit"
import SliceConnectButton from "../ConnectButton"
import { useSIWEAccount } from "react-walletkit"
import { Button, ButtonProps } from "../ui/base/button"
import { shortenAddress } from "@/src/lib/shortenAddress"
import { useSliceContext } from "../SliceProvider"
import sliceLogo from "@/src/public/sliceLogo.png"
import { cn } from "@/src/lib/utils"

const ConnectBlock = ({
  buttonProps,
  smartWalletEnabled = true
}: {
  buttonProps?: ButtonProps
  smartWalletEnabled?: boolean
}) => {
  const { isConnected, accountBalance, theme } = useSliceContext()
  const { cartButtonColor } = theme
  const { connect, connectors } = useConnect()

  const { address: signerWallet, connector: signerConnector } = useSIWEAccount()
  const { address: smartWallet, connector } = useAccount({
    onDisconnect: () => {
      if (signerConnector && connectors.find((c) => c == signerConnector)) {
        connect({ connector: signerConnector })
      }
    }
  })
  const displayedAddress: `0x${string}` = signerWallet || smartWallet

  const { data: ensName } = useEnsName({
    address: displayedAddress,
    chainId: 1
  })
  const { data: avatar } = useEnsAvatar({
    name: ensName,
    chainId: 1
  })
  const { openAccountModal } = useAccountModal()

  return isConnected ? (
    <div className="sl-flex sl-items-center sl-gap-3">
      <Button
        variant="outline"
        className={cn("sl-font-semibold sl-px-2 sm:sl-px-4", cartButtonColor)}
        onClick={openAccountModal}
      >
        <img
          src={avatar || sliceLogo}
          alt={ensName + " avatar"}
          className="sl-rounded-full sl-w-[22px] sl-h-[22px]"
        />
        <p className="sl-text-xs sm:sl-text-sm">
          {ensName || shortenAddress(displayedAddress, "...")}{" "}
          {signerWallet && (
            <span className="sl-text-xs sm:sl-text-[0.8rem]">
              (smart wallet)
            </span>
          )}
        </p>
        <div className="sl-bg-muted-foreground sl-w-[1px] sl-h-[18px] sm:sl-mx-1" />
        <p className="sl-text-xs sm:sl-text-sm">
          USDC{" "}
          {accountBalance
            ? Math.floor(Number(accountBalance.formatted) * 100) / 100
            : "..."}
        </p>
      </Button>
      {connector?.id !== "walletkit" && smartWalletEnabled && (
        <SliceConnectButton {...buttonProps} />
      )}
    </div>
  ) : (
    <SliceConnectButton {...buttonProps} />
  )
}

export default ConnectBlock
